import { useParams } from 'react-router-dom';

import usePermissions from 'api/usePermissions';
import { EAnalyticsState } from 'constants/navigation';
import { useIsSlaPageEnabled } from 'hooks/useIsSlaPageEnabled';

import {
  getAccessibleAnalyticsTabs,
  getDefaultAnalyticsTab
} from './analyticsTabsAccess';

interface IAnalyticsTabsAccess {
  accessibleTabs: EAnalyticsState[];
  defaultTab: EAnalyticsState;
}

export const useAnalyticsTabsAccess = (): IAnalyticsTabsAccess => {
  const { publisherId } = useParams();
  const { getPermissions } = usePermissions();
  const isSlaPageEnabled = useIsSlaPageEnabled();
  const permissions = getPermissions();
  const projectId = publisherId || '';

  return {
    accessibleTabs: getAccessibleAnalyticsTabs(
      permissions,
      projectId,
      isSlaPageEnabled
    ),
    defaultTab: getDefaultAnalyticsTab(permissions, projectId, isSlaPageEnabled)
  };
};
